import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "student-group-confirm-delete-alert",
  "use": "student-group-confirm-delete-alert-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 30\" id=\"student-group-confirm-delete-alert\"><path d=\"M15 0c8.288 0 15 6.712 15 15s-6.712 15-15 15S0 23.288 0 15 6.712 0 15 0zm1.5 7.5h-3v9h3v-9zm0 12h-3v3h3v-3z\" fill=\"currentColor\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol